import { useSelector } from "react-redux";
import store from "../storeWire";
import {
    add_part_to_bom,
    bom_assign_to_project,
    bomDownloadFile,
    bomEmailFile,
    bomUploadFile,
    copyBOMByBomID,
    create_blank_bom,
    create_bom,
    create_part_list,
    deleteBOMByBomID,
    download_bom_template,
    edit_bom_name,
    fetchBOMList,
    fetchDownloadFileSavePreference,
    fetchProductCategoryList,
    FORCE_remove_bomDetailByBomIDWithType_by_type,
    getBomDetailByBomID,
    getBomDetailByBomIDWithType,
    getBomDetailCountByBomID,
    getBomHealthByBomID,
    remove_part_number,
    set_is_rematch_flag,
    swap_part_number,
    updateCustomerPartNumberByBomDetailID,
    updateQuantityByBomDetailID,
    SET_bomSortByUpdatedDate,
    getFarnellBomList
} from "../store/slice/model/BOM";
import useReduxState from "./useReduxState";
import Common from "../pages/BOM/Common";
import { useSearchParams } from "react-router-dom";
import BOMAPICall from "src/service/BOMAPICall";
import BOMRepository from "src/repository/BOMRepository";

export function useBOMStore() {
    const bom_list = useSelector((state) => state.entities.model_BOM.bomList)
    const bom_detail_by_bom_id = useSelector((state) => state.entities.model_BOM.bomDetailByBomID)
    const bom_health_by_bom_id = useSelector((state) => state.entities.model_BOM.bomHealthByBomID)
    const bom_detail_by_bom_id_type = useSelector((state) => state.entities.model_BOM.bomDetailByBomIDWithType)
    const bomUploadFile__progress_percentage = useSelector((state) => state.entities.model_BOM.bomUploadFile__progress_percentage)
    const bomMultipleMatchTrigger = useSelector((state) => state.entities.model_BOM.bomMultipleMatchTrigger)
    const bomSortByUpdatedDate = useSelector((state) => state.entities.model_BOM.bomSortByUpdatedDate)
    const farnell_bom_list = useSelector((state) => state.entities.model_BOM.farnellBomList)
    /**
     * Owner : Trilok
     * Date  : 08/02/2023
     * Note  : Initialize top variable with 20 in each tab.
     */
    const [top] = useReduxState({
        NoMatch: { top: 20 },
        Multiple: { top: 20 },
        Exact: { top: 20 }
    }, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT');
    const [searchParams] = useSearchParams();
    const [BomTabList__Component__Loader] = useReduxState(searchParams.get(Common.param_key_BomTabList) ? searchParams.get(Common.param_key_BomTabList) : Common.default_component_BomTabList.param_value, Common.redux_key_BomTabList, 'BomTabList__Component__Loader');
    let data = {
        bom_list,
        bom_detail_by_bom_id,
        bom_health_by_bom_id,
        bomUploadFile__progress_percentage,
        bom_detail_by_bom_id_type,
        bomMultipleMatchTrigger,
        bomSortByUpdatedDate,
        farnell_bom_list
    };
    let fetch = {
        fetch_bom_list: async () => {
            return await store.dispatch(fetchBOMList())
        },
        fetch_product_category_list: async () => {
            return await store.dispatch(fetchProductCategoryList())
        },
        get_bom_detail_by_bom_id: async (params) => {
            return await store.dispatch(getBomDetailByBomID(params))
        },
        get_bom_detail_count_by_bom_id: async (params) => {
            return await store.dispatch(getBomDetailCountByBomID(params))
        },
        get_bom_health_by_bom_id: async (params) => {
            return await store.dispatch(getBomHealthByBomID(params))
        },
        get_bom_detail_by_bom_id_with_type: async (params) => {
            return await store.dispatch(getBomDetailByBomIDWithType(params))
        },
        get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui: async (bomId, isAfterAddedPart = false) => {
            Object.entries(Common.chain_BomTabList).map(async (v) => {
                store.dispatch(FORCE_remove_bomDetailByBomIDWithType_by_type({
                    matchType: v[1].api_fetch_type
                }));
            });

            if (BomTabList__Component__Loader !== undefined) {
                let topHere = 20;
                if (top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type] !== undefined && top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top !== undefined) {
                    topHere = top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top
                }

                let param = {
                    bomId: bomId,
                    isReRunPartMatch: false,
                    matchType: Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type,
                    top: topHere,
                    sortColumn: isAfterAddedPart ? "updated_date" : "sequence_number",
                    sortOrder: isAfterAddedPart ? "desc" : "asc"
                }

                if (isAfterAddedPart) {
                    store.dispatch(SET_bomSortByUpdatedDate(true));
                    param.top = 20
                    // param.skip = 0
                }

                await store.dispatch(getBomDetailByBomIDWithType(param));
            }
        },
        bom_upload_file: async (params) => {
            return await store.dispatch(bomUploadFile(params))
        },
        fetch_download_file_preference: async (params) => {
            return await store.dispatch(fetchDownloadFileSavePreference(params))
        },
        fetch_cross_reference_parts: async(params) => {
            return await store.dispatch()
        },
        fetch_Farnell_bom_list: async (params) => {
            return await store.dispatch(getFarnellBomList(params))
        },
    };
    let set = {
        create_bom: async (params) => {
            return await store.dispatch(create_bom(params))
        },
        create_blank_bom: async () => {
            return await store.dispatch(create_blank_bom())
        },
        delete_bom_by_bom_id: async (params) => {
            return await store.dispatch(deleteBOMByBomID(params))
        },
        copy_bom_by_bom_id: async (params) => {
            return await store.dispatch(copyBOMByBomID(params));
        },
        edit_bom_name: async (params) => {
            return await store.dispatch(edit_bom_name(params))
        },
        set_is_rematch_flag: async (params) => {
            return await store.dispatch(set_is_rematch_flag(params))
        },
        add_part_to_bom: async (params) => {
            return await store.dispatch(add_part_to_bom(params))
        },
        download_bom_template: async () => {
            return await store.dispatch(download_bom_template())
        },
        bom_download_file: async (params) => {
            return await store.dispatch(bomDownloadFile(params))
        },
        bom_email_file: async (params) => {
            return await store.dispatch(bomEmailFile(params))
        },
        create_part_list: async (params) => {
            return await store.dispatch(create_part_list(params))
        },
        bom_assign_to_project: async (params) => {
            return await store.dispatch(bom_assign_to_project(params))
        },
        swap_part_number: async (params) => {
            return await store.dispatch(swap_part_number(params))
        },
        update_quantity_by_bom_detail_by_id: async (params) => {
            return await store.dispatch(updateQuantityByBomDetailID(params))
        },
        update_customer_part_number_by_bom_detail_by_id: async (params) => {
            return await store.dispatch(updateCustomerPartNumberByBomDetailID(params))
        },
        remove_part_number: async (params) => {
            return await store.dispatch(remove_part_number(params))
        },
        bom_upload_progress: async (params) => {
            return await new BOMAPICall().bomUploadProgress({ bomId: params.bomId })
        },
        update_display_order: async (params) => {
            return await new BOMAPICall().updateDisplayOrder(params)
        },
        save_download_file_preference: async(params) => {
            return await new BOMRepository().saveDownloadFilePreference(params);
        },
        update_Farnell_Qte: async (params) => {
            return await new BOMRepository().updateFarnellQte(params)
        },
    };
    return [data, fetch, set]
}